import { useMemo } from 'react'
import { createLayeredContext } from '@/contexts/layered-context'

const { Provider, useProvide, useValue } = createLayeredContext<
  string | number | null
>(0, {
  excludeNulls: true,
})

export { Provider as PageBottomOffsetContextProvider }

/**
 * Provides an offset for the page bottom.
 *
 * @param offset
 * @param priority
 */
export function useProvidePageBottomOffset(
  offset: string | number | null,
  priority?: number,
) {
  return useProvide(offset, priority)
}

/**
 * Gets the offset to apply to elements that are positioned relative to the bottom
 * of the page. Use cases include ensuring that snackbars do not overlay the
 * global navigation bar when the latter is positioned at the bottom.
 */
export function usePageBottomOffset() {
  const offset = useValue() ?? 0
  return useMemo(
    () => (typeof offset === 'number' ? `${offset}px` : offset),
    [offset],
  )
}
